import { runClientComponent } from '../../_common/client/client-component-runner';
import { OnlineMarketingComponent } from './online-marketing.component';

runClientComponent({ ExactagComponent: OnlineMarketingComponent });
